import { useState } from "react";
import {
  Checkbox,
  Modal,
  PrimaryButton,
  MarkdownViewer,
} from "@ever-tutor/et-ui";

const TermsAndConditions = ({
  isChecked,
  setIsChecked,
}: {
  isChecked: boolean;
  setIsChecked: (isChecked: boolean) => void;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModalOpen = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setIsChecked(true);
  };

  return (
    <div className="py-6">
      <Checkbox
        checked={isChecked}
        onChange={setIsChecked}
        aria-label="Agree to Terms and Conditions"
      >
        <p className="text-md font-mulish">
          Agree to the{" "}
          <a
            href="#"
            className="text-darkgreen hover:text-darkgreen font-libre-baskerville italic underline font-medium"
            onClick={handleModalOpen}
          >
            Terms and Conditions & Privacy Policy
          </a>
        </p>
      </Checkbox>

      <Modal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        showCloseButton={true}
        aria-label="Terms and Conditions Modal"
      >
        <div className="p-8">
          <div className="flex flex-col gap-6 text-black text-md leading-relaxed font-mulish">
            <MarkdownViewer
              filePath="/files/privacypolicy.md"
              aria-label="Privacy Policy Content"
            />

            <PrimaryButton
              onClick={handleModalClose}
              aria-label="Accept and Continue"
            >
              Accept and Continue
            </PrimaryButton>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default TermsAndConditions;
